import { Injectable } from '@angular/core';
import { PopoverService } from 'src/@vex/components/popover/popover.service';
import { map, startWith, switchMap } from 'rxjs/operators';
import { Observable, of } from 'rxjs';
import { UploadQuestionsComponent } from './upload-questions/upload-questions.component';
import { AutoDpsComponent } from './auto-dps/auto-dps.component';
import { ExamCopyComponent } from './exam-copy/exam-copy.component';
import { ExamUrlComponent } from './exam-url/exam-url.component';
import { PauseUnpauseExamComponent } from './pause-unpause-exam/pause-unpause-exam.component';
import { TestQuestionsComponent } from './test-questions/test-questions.component';
import { ExportQuestionsComponent } from './export-questions/export-questions.component';
import { Router, UrlSerializer } from '@angular/router';
import { ExamService } from 'src/app/services/exam-service.service';
import { SnackbarService } from 'src/app/services/snackbar.service';
import { ScheduleCandidateComponent } from './schedule-candidate/schedule-candidate.component';
import { ImportScheduleCandidateComponent } from './import-schedule-candidate/import-schedule-candidate.component';
import { TemplateDownloadComponent } from './template-download/template-download.component';
import { GenerateSebConfigComponent } from 'src/app/exam-layout/operations/generate-seb-config/generate-seb-config.component';
import { id } from 'date-fns/locale';
import { UploadQuestionsImageComponent } from './upload-questions-image/upload-questions-image.component';
import { UploadMarksheetComponent } from './upload-marksheet/upload-marksheet.component';
import { AssignExaminersComponent } from './assign-examiners/assign-examiners.component';
import { ExamInstructionsComponent } from './exam-instructions/exam-instructions.component';
import { ImportCandidatesDataComponent } from './ImportCandidatesData/ImportCandidatesData.component';
import { AuthService } from 'src/app/services/http-services/authservice.service';
import { UploadContext } from 'src/app/interface/dto';

@Injectable({
  providedIn: 'root'
})
export class ExamOperationService {
  opOpen$: Observable<boolean> = of(false);

  constructor(private popoverService: PopoverService, private router: Router, private serializer: UrlSerializer, private examService: ExamService, private snackBar: SnackbarService, private auth: AuthService,) { }

  async processExamOperation(route: any, origin: any) {

    let selectedExamID = this.examService.selectedExamIds[0];
    let selectedExam = this.examService.selectedExams[0];
    if (route == 'operations/exam/pausestatus') {
      this.openModal(origin, PauseUnpauseExamComponent);
      return;
    }
    if (route == 'operations/exam/test') {
      this.openModal(origin, TestQuestionsComponent);
      return;
    }
    if (route.match("operations/exam/defaultproctor")) {
      await this.examService.setUpDefaultProctor(selectedExamID).then((res: any) => {
        this.snackBar.success('Proctors Scheduled Successfully');
        this.examService.reloadGrid.next(true);
      });
      return;
    }
    if (route.match("operations/exam/publish_questions")) {
      let data = { "ExaminationIDs": this.examService.selectedExamIds, "SelectAllExam": this.examService.selectAll };
      await this.examService.publishQuestions(data).then((res: any) => {
        this.snackBar.success('Questions Published Successfully');
        this.examService.reloadGrid.next(true);
      });
      return;
    }
    if (route.match("operations/exam/import_candidates_data")) {
      this.openModal(origin, ImportCandidatesDataComponent);
      return;
    }
    if (route == 'operations/exam/downloadExamCandidates') {
      this.openModal(origin, TemplateDownloadComponent);
      return;
    }
    if (this.examService.selectedExams?.length > 1) {
      this.snackBar.warning('Multiple Examinations Selected');
      return;
    }

    if (route == 'operations/exam/question/upload') {
      this.openModal(origin, UploadQuestionsComponent, UploadContext.Exam);
    }
    if (route == 'operations/exam/question/uploadimage') {
      this.openModal(origin, UploadQuestionsImageComponent);
    }
    if (route == 'operations/exam/uploadmarksheet') {
      this.openModal(origin, UploadMarksheetComponent);
    }
    if (route == 'operations/exam/exams/examurl') {
      this.openModal(origin, ExamUrlComponent);
    }
    if (route == 'operations/exam/questions/copy') {
      this.openModal(origin, ExamCopyComponent);
    }

    if (route == 'operations/exam/generatedps') {
      this.openModal(origin, AutoDpsComponent);
    }

    if (route == 'operations/exam/questions/export') {
      this.openModal(origin, ExportQuestionsComponent);
    }

    if (route == 'operations/exam/questions') {
      this.router.navigate([`exams/${selectedExamID}/questions`]);
    }

    if (route == 'operations/exam/schedule') {
      this.openModal(origin, ImportScheduleCandidateComponent);
    }
    if (route == 'operations/exam/uploadExamCandidates') {
      this.openModal(origin, ScheduleCandidateComponent);
    }


    if (route.match("operations/exam/generatesebconfig")) {
      this.openModal(origin, GenerateSebConfigComponent);
    }



    if (route.match("operations/exam/autoMarkSAQ")) {
      if (selectedExam.examinationTypeenum != "SAQ") {
        this.snackBar.warning('SAQ Exam Not Selected');
        return;
      }
      let data = { ExaminationID: selectedExamID };
      await this.examService.autoMarkSAQ(data).then((res: any) => {
        this.snackBar.success('Auto Marked SAQ Exams Successfull');
      });
    }
    if (route.match("operations/exam/markSaq")) {
      if (selectedExam.examinationTypeenum != "SAQ") {
        this.snackBar.warning('SAQ Exam Not Selected');
        return;
      }
      this.router.navigate([`exams/${selectedExamID}/marksaq`], {
        queryParams: { mode: 'mark' }
      });
    }
    if (route.match("operations/exam/reviewSaq")) {
      if (selectedExam.examinationTypeenum != "SAQ") {
        this.snackBar.warning('SAQ Exam Not Selected');
        return;
      }
      this.router.navigate([`exams/${selectedExamID}/marksaq`], {
        queryParams: { mode: 'review' }
      });
    }
    if (route.match("operations/exam/markEssay")) {
      if (selectedExam.examinationTypeenum != "Essay") {
        this.snackBar.warning('Essay Exam Not Selected');
        return;
      }
      this.router.navigate([`exams/${selectedExamID}/markessay`], {
        queryParams: { mode: 'mark' }
      });
    }
    if (route.match("operations/exam/reviewEssay")) {
      if (selectedExam.examinationTypeenum != "Essay") {
        this.snackBar.warning('Essay Exam Not Selected');
        return;
      }
      this.router.navigate([`exams/${selectedExamID}/markessay`], {
        queryParams: { mode: 'review' }
      });
    }
    if (route.match("operations/exam/sendemailmessages")) {
      this.router.navigate([`exams/email-messages`]);
    }
    if (route.match("operations/exam/senddefaultemailmessages")) {
      this.router.navigate([`exams/email-messages`], {
        queryParams: { mode: 'default' }
      });
    }

    if (route == 'operations/exam/assignexaminers') {
      this.openModal(origin, AssignExaminersComponent);
    }
    if (route == 'operations/exam/monitor') {
      let accesscode = selectedExam.proctorAccessCodes.split(',').find(code => code.trim() !== '');
      window.open(this.router.serializeUrl(
        this.router.createUrlTree(['/monitor'], { queryParams: { accesscode, fullName: this.auth.user.fullName } })
      ), '_blank');
    }
    if (route == 'operations/exam/recordings') {
      this.router.navigate([`exams/${selectedExamID}/recordings`]);
    }
    if (route == 'operations/exam/flags') {
      this.router.navigate([`exams/${selectedExamID}/flags`]);
    }
  }

  async processExamSetUp(route: any, origin: any) {

    let selectedExamID = this.examService.selectedExamIds[0];
    if (this.examService.selectedExams?.length > 1) {
      this.snackBar.warning('Multiple Examinations Selected');
      return;
    }
    if (route == 'operations/exam/category') {
      this.router.navigate([`exams/${selectedExamID}/category`]);
    }
    if (route == 'operations/exam/instructions') {
      this.openModal(origin, ExamInstructionsComponent);
    }
    if (route == 'operations/exam/questiongroups') {
      this.router.navigate([`/exams/${selectedExamID}/questiongroups`]);
    }
   if (typeof route === 'object' && route.path) {
     this.router.navigate([route.path], { queryParams: route.queryParams });
    }


  }

  async processQuestionOperation(route: any, origin: any) { 
    let questionIds = this.examService.selectedQuestionsIds ;
    // const reportTree = this.router.createUrlTree([], { queryParams: questionIds });
    // let params = this.serializer.serialize(reportTree).split('?', 2)[1];

    if (route == 'operations/questions/disableEnableQuestions') { 
      this.examService.changeQuestionStatus(questionIds).then(s => {
        this.snackBar.success('Question status updated successfully');
        this.examService.reloadGrid.next(true);
      });
    }
   
  }
  public openModal(origin: any, _classtype: any,  context?: UploadContext) {
    this.opOpen$ = of(
      this.popoverService.open({
        content: _classtype,
        origin,
        width: 2000,
        offsetY: 12,
        data: { context },
        position: [
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'bottom'
          }, {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'bottom'
          }
        ]
      })
    ).pipe(
      switchMap(popoverRef => popoverRef.afterClosed$.pipe(map(() => false))),
      startWith(true),
    );
  }

  public operationExamList() {
    return [
      {
        icon: 'mat:cloud_upload',
        label: 'Import Questions',
        route: 'operations/exam/question/upload',
        id: 'examinations_import_questions'
      },
      {
        icon: 'mat:cloud_upload',
        label: 'Upload Questions Image',
        route: 'operations/exam/question/uploadimage',
        id: 'examinations_upload_questions_image'
      },
      {
        icon: 'mat:cloud_upload',
        label: 'Upload MarkSheet',
        route: 'operations/exam/uploadmarksheet',
        id: 'examinations_upload_marksheet'
      },
      {
        icon: 'mat:calendar_today',
        label: 'Schedule Candidates',
        route: 'operations/exam/schedule',
        id: 'examinations_schedule_candidates'
      },
      {
        icon: 'mat:file_copy',
        label: 'Copy Exam Questions',
        route: 'operations/exam/questions/copy',
        id: 'examinations_copy_exam_questions'
      },
      {
        icon: 'mat:import_export',
        label: 'Export Exam Questions',
        route: 'operations/exam/questions/export',
        id: 'examinations_export_exam_questions'
      },
      {
        icon: 'mat:pause',
        label: 'Pause/Un-Pause Exam',
        route: 'operations/exam/pausestatus',
        id: 'examinations_pause_unpause_exam'
      },
      {
        icon: 'mat:question_answer',
        label: 'Test Questions',
        route: 'operations/exam/test',
        id: 'examinations_test_questions'
      },
      {
        icon: 'mat:speaker_notes',
        label: 'Publish Questions',
        route: 'operations/exam/publish_questions',
        id: 'examinations_publish_questions'
      },
      {
        icon: 'mat:web_asset',
        label: 'Generate Registration URL',
        route: 'operations/exam/exams/examurl',
        id: 'generate_registration_url'
      },
      {
        icon: 'mat:brightness_auto',
        label: 'Auto-generate Proctor Schedule',
        route: 'operations/exam/generatedps',
        id: 'examinations_auto_generate_proctor_schedule'
      },
      {
        icon: 'mat:brightness_auto',
        label: 'SetUp Default Proctor',
        route: 'operations/exam/defaultproctor',
        id: 'examinations_setup_default_proctor'
      },
      {
        icon: 'mat:send',
        label: 'Send Email Messages',
        route: 'operations/exam/sendemailmessages',
        id: 'examinations_send_email_messages'
      },
      {
        icon: 'mat:send',
        label: 'Send Default Email Messages',
        route: 'operations/exam/senddefaultemailmessages',
        id: 'examinations_send_default_email_messages'
      },
      // {
      //   icon: 'mat:import_export',
      //   label: 'Upload Exam Candidates',
      //   route: 'operations/exam/uploadExamCandidates',
      // },
      {
        icon: 'mat:import_export',
        label: 'Download Templates Sample',
        route: 'operations/exam/downloadExamCandidates',
        id: 'examinations_download_schedule_template'
      },

      {
        icon: 'mat:create_new_folder',
        label: 'Generate SEB Config',
        route: 'operations/exam/generatesebconfig',
        id: 'examinations_generate_seb_config'
      }
      ,
      {
        icon: 'mat:create_new_folder',
        label: 'Import Exam Candidates data',
        route: 'operations/exam/import_candidates_data',
        id: 'examinations_import_candidates_exam_data'
      },
      {
        icon: 'mat:brightness_auto',
        label: 'Auto Mark SAQ',
        route: 'operations/exam/autoMarkSAQ',
        id: 'examinations_auto_mark_saq'
      }
      ,
      {
        icon: 'mat:playlist_add_check',
        label: 'Mark SAQ',
        route: 'operations/exam/markSaq',
        id: 'examinations_mark_saq_exam'
      }
      ,
      {
        icon: 'mat:pageview',
        label: 'Review SAQ',
        route: 'operations/exam/reviewSaq',
        id: 'examinations_review_saq_exam',
      }
      ,
      {
        icon: 'mat:playlist_add_check',
        label: 'Mark Essay',
        route: 'operations/exam/markEssay',
        id: 'examinations_mark_essay_exam'
      },
      {
        icon: 'mat:pageview',
        label: 'Review Essay',
        route: 'operations/exam/reviewEssay',
        id: 'examinations_review_essay_exam'
      },
      {
        icon: 'mat:assignment_ind',
        label: 'Assign Examiners',
        route: 'operations/exam/assignexaminers',
        id: 'examinations_assign_examiners'
      },
      {
        icon: 'mat:laptop_chromebook',
        label: 'Monitor Examination',
        route: 'operations/exam/monitor',
        id: 'examinations_proctors'
      },
      {
        icon: 'mat:playlist_play',
        label: 'View Examination Recordings',
        route: 'operations/exam/recordings',
        id: 'examinations_proctors'
      },
      {
        icon: 'mat:flag',
        label: 'View Examination Flags',
        route: 'operations/exam/flags',
        id: 'examinations_proctors'
      }
    ];
  }
  public setUpExamList() {
    return [
      {
        icon: 'mat:create_new_folder',
        label: 'Categories',
        route: 'operations/exam/category',
        id: 'examinations_categories'
      },
      {
        icon: 'mat:group_work',
        label: 'Question Groups',
        route: `operations/exam/questiongroups`,
        id: 'examinations_question_groups'
      },
      {
        icon: 'mat:image_aspect_ratio',
        label: 'Set Instructions',
        route: 'operations/exam/instructions',
        id: 'examinations_set_instructions'
      }
    ];
  }
  public questionOperationList() {
    return [
      {
        icon: 'mat:cancel_presentation',
        label: 'Disable/Enable Questions',
        route: 'operations/questions/disableEnableQuestions',
        id: 'examinationquestions_toggle_disabled'
      },
    ]
  }
}
